import React from "react"

const NewsListingPlaceholderBlock = ({ block }) => {
  return (<div id={block.uid} data-info={`this is a technical placeholder, preview is not available`}></div> )
}

export default NewsListingPlaceholderBlock
